'use client';

import { c as _c } from "react/compiler-runtime";
import { canAuthorizeWithdrawal } from '@morfi/onramp-sdk';
import type { useWithdrawalCheckout } from '@morfi/onramp-sdk/react';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { AnimatedButton } from '@/components/ui/animated-button';
import { WithdrawalReceiptContent } from '../history/funding-receipt';
import { SellProviderFrame } from './sell-provider-frame';
type Flow = ReturnType<typeof useWithdrawalCheckout>;
type Command = Parameters<Flow['commands']['mutateAsync']>[0];
export function WithdrawOperationScreen(t0) {
  const $ = _c(19);
  const {
    flow,
    expired,
    retryRequest,
    run,
    send,
    onClose
  } = t0;
  const t = useTranslations("onramp");
  const operation = flow.operation.data;
  const evidence = operation?.withdrawal;
  let t1;
  if ($[0] !== evidence?.recipient || $[1] !== evidence?.sendReserved || $[2] !== flow.hostedUrl || $[3] !== operation?.status || $[4] !== t) {
    t1 = flow.hostedUrl ? <div hidden={operation?.status !== "action_required" && Boolean(evidence?.recipient || evidence?.sendReserved || ["delivered", "failed", "cancelled", "refunded"].includes(operation?.status ?? ""))}><h3 className="text-heading-sm">{t("withdraw_account")}</h3><p className="text-caption text-foreground-secondary">{t("withdraw_account_hint")}</p><SellProviderFrame url={flow.hostedUrl} /></div> : null;
    $[0] = evidence?.recipient;
    $[1] = evidence?.sendReserved;
    $[2] = flow.hostedUrl;
    $[3] = operation?.status;
    $[4] = t;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== evidence || $[7] !== expired || $[8] !== flow || $[9] !== onClose || $[10] !== operation || $[11] !== retryRequest || $[12] !== run || $[13] !== send || $[14] !== t) {
    t2 = operation ? <><WithdrawalReceiptContent operation={operation} />{(flow.operation.isError || flow.resumeError) && !flow.canReport && !canAuthorizeWithdrawal(operation.status, evidence) ? <AnimatedButton loading={flow.operation.isFetching} onClick={retryRequest}>{t(expired ? "sign_in" : "retry")}</AnimatedButton> : null}{flow.canReport ? <AnimatedButton loading={flow.commands.isPending} disabled={flow.commands.isPending} onClick={() => run({
        kind: "report"
      })}>{t("retry")}</AnimatedButton> : null}{canAuthorizeWithdrawal(operation.status, evidence) ? <AnimatedButton loading={flow.commands.isPending} disabled={flow.commands.isPending} onClick={() => flow.operation.isError ? retryRequest() : run({
        kind: "send",
        send
      })}>{expired ? t("sign_in") : flow.commands.isError || flow.operation.isError ? t("retry") : t("withdraw_send")}</AnimatedButton> : null}{!evidence?.sendReserved && ["created", "awaiting_payment"].includes(operation.status) ? <AnimatedButton variant="tertiary" onClick={() => run({
        kind: "cancel"
      })}>{t("cancel")}</AnimatedButton> : null}{["delivered", "failed", "cancelled", "refunded"].includes(operation.status) ? <AnimatedButton onClick={() => {
        flow.finish();
        onClose();
      }}>{t("done")}</AnimatedButton> : null}</> : null;
    $[6] = evidence;
    $[7] = expired;
    $[8] = flow;
    $[9] = onClose;
    $[10] = operation;
    $[11] = retryRequest;
    $[12] = run;
    $[13] = send;
    $[14] = t;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  let t3;
  if ($[16] !== t1 || $[17] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[16] = t1;
    $[17] = t2;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  return t3;
}